import { Box, Typography, Divider, Button, IconButton } from "@mui/material";
import { SummaryCount } from "./styles";
import pxToRem from "theme/base/pxToRem";
import { SummaryTimeSheet } from "./SummaryTimeSheet";
import { TimeSheet } from "./TimeSheet";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMonthYearTimeKeepingMonth,
  timeCheckingMonthDataSelector,
} from "modules/DeclareLeave/redux/selector";
import { useLegacyEffect } from "helper/customHook";
import {
  getTimeCheckingMonthStart,
  setMonthYearTimeCheckingMonth,
} from "modules/DeclareLeave/redux/getTimekeepingMonth";
import { SCREEN } from "helper/roleChecker/Screens";
import { ConfirmStatus } from "core/http/service/decleareLeave/resTypes";
import { ReactComponent as IconCheck } from "assets/svg/20-check-circle-fill.svg";
import { confirmTimeKeepingMonthStart } from "modules/DeclareLeave/redux/confirmTimeKeepingMonth";
import { exportTimeKeepingMonthStart } from "modules/DeclareLeave/redux/exportTimeKeepingMonth";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/vi"; // Import Vietnamese locale
import { ReactComponent as IconArrowHeadDown } from "assets/svg/20-arrowhead-down.svg";

import { useState } from "react";
import { useParams } from "react-router-dom";

const MonthlyTimeSheet = () => {
  const data = useSelector(timeCheckingMonthDataSelector);
  const { month, year } = useSelector(selectMonthYearTimeKeepingMonth);
  const [monthSelected, setMonthSelected] = useState(moment());
  const { tab } = useParams();
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const locale = "vi";
  if (moment.locale() !== locale) {
    moment.locale(locale);
  }
  useLegacyEffect(() => {
    dispatch(
      getTimeCheckingMonthStart({
        month,
        year,
        screenCode: SCREEN.IP_018,
      })
    );

    return () => {
      handleChangeMonth(moment());
    };
  }, [tab]);

  const getConfirmButton = (type: string) => {
    switch (type) {
      case "label":
        switch (data.confirmStatus) {
          case ConfirmStatus.READY:
            return "Gửi xác nhận ngày công";
          case ConfirmStatus.NOT_READY:
            return "Đang chờ xác nhận";
          case ConfirmStatus.APPROVE:
            return "Đã gửi xác nhận chấm công";
          case ConfirmStatus.EXPIRED_DATE:
            return "Đã gửi xác nhận chấm công tự động";
          case ConfirmStatus.AUTO_APPROVED:
            return "Đã gửi xác nhận chấm công tự động";
          case ConfirmStatus.REFUSED:
            return "Xác nhận chấm công bị từ chối";
          default:
            return "Gửi xác nhận ngày công";
        }
      case "background":
        switch (data.confirmStatus) {
          case ConfirmStatus.READY:
            return "primary";
          case ConfirmStatus.NOT_READY:
            return "disabled";
          case ConfirmStatus.CONFIRMED:
            return "success";
          case ConfirmStatus.EXPIRED_DATE:
            return "success";
          default:
            return "primary";
        }
      case "icon":
        switch (data.confirmStatus) {
          case ConfirmStatus.READY:
            return <></>;
          case ConfirmStatus.NOT_READY:
            return <></>;
          case ConfirmStatus.CONFIRMED:
            return <IconCheck />;
          case ConfirmStatus.EXPIRED_DATE:
            return <IconCheck />;
          default:
            return <></>;
        }
      case "variant":
        switch (data.confirmStatus) {
          case ConfirmStatus.READY:
            return "contained";
          case ConfirmStatus.NOT_READY:
            return "outlined";
          case ConfirmStatus.CONFIRMED:
            return "blur";
          case ConfirmStatus.EXPIRED_DATE:
            return "blur";
          default:
            return "outlined";
        }
    }
  };

  const handleChangeMonth = (newValue: any) => {
    const timeSelected = {
      month: newValue.month() + 1,
      year: newValue.year(),
    };
    dispatch(setMonthYearTimeCheckingMonth(timeSelected));
    setMonthSelected(newValue);
    dispatch(
      getTimeCheckingMonthStart({
        month: newValue.month() + 1,
        year: newValue.year(),
        screenCode: SCREEN.IP_018,
      })
    );
    // fetchData(newValue);
  };

  const handleSubmit = () => {
    if (data.confirmStatus !== ConfirmStatus.READY) return;
    dispatch(
      confirmTimeKeepingMonthStart({
        month,
        year,
        screenCode: SCREEN.IP_018,
      })
    );
  };

  const exportExcel = () => {
    dispatch(
      exportTimeKeepingMonthStart({
        month,
        year,
        screenCode: SCREEN.IP_018,
      })
    );
  };

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2.5} p={2}>
      {/* Header: Title + Select range */}
      <Box display={"flex"} alignItems={"center"}>
        <Typography
          sx={(theme) => ({
            fontSize: theme.typography.size.lg_18,
            fontWeight: theme.typography.fw_semibold_600,
            color: theme.palette.text.textPrimary,
          })}
          onClick={() => setOpen(!open)}
        >
          Bảng chấm công {moment(data?.fromDate).format("DD/MM")} -{" "}
          {moment(data?.toDate).format("DD/MM")}
        </Typography>

        <LocalizationProvider
          dateAdapter={AdapterMoment}
          adapterLocale={locale}
        >
          <DatePicker
            views={["month", "year"]}
            sx={(theme) => ({
              fieldset: {
                border: "none",
              },
              ".MuiInputBase-root.MuiOutlinedInput-root": {
                paddingRight: 0,
                input: {
                  width: pxToRem(10),
                  textTransform: "capitalize",
                  color: theme.palette.text.textPrimary,
                  cursor: "pointer",
                  padding: 0,
                  // display: "none",
                  opacity: 0,
                },
              },
              ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                opacity: 0,
                position: "absolute",
                right: pxToRem(50),
                background: "pink",
                button: {
                  width: pxToRem(140),
                  background: "pink",
                  marginRight: `-${pxToRem(105)}`,
                },
              },
            })}
            value={monthSelected}
            format="MM"
            onChange={handleChangeMonth}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            openTo="month"
            closeOnSelect={true}
            slots={{ actionBar: () => null }}
          />
        </LocalizationProvider>
        <IconButton
          sx={(theme) => ({
            svg: {
              path: {
                fill: theme.palette.icon.icPrimary,
              },
            },
          })}
          onClick={() => setOpen(!open)}
        >
          <IconArrowHeadDown />
        </IconButton>
      </Box>
      <TimeSheet timeSheetData={data?.workDays ?? {}} />

      <SummaryTimeSheet timeKeepingData={data?.leaveReasons} />
      <SummaryCount>
        <Typography
          sx={(theme) => ({
            fontSize: theme.typography.size.sm_14,
            textTransform: "uppercase",
            fontWeight: theme.typography.fw_semibold_600,
            color: theme.palette.text.textPrimary,
          })}
        >
          Tổng cộng ngày công tính lương nhân sự:
        </Typography>
        <Typography
          sx={(theme) => ({
            fontSize: theme.typography.size.sm_14,
            textTransform: "uppercase",
            fontWeight: theme.typography.fw_semibold_600,
            color: theme.palette.text.textLink,
          })}
        >
          {data.totalWorkDays} NGÀY CÔNG
        </Typography>
      </SummaryCount>
      <Divider />
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        {data.message && (
          <Typography
            sx={(theme) => ({
              color: theme.palette.text.textNegative,
              fontSize: 14,
            })}
          >
            {data.message}
          </Typography>
        )}
        <Box display={"flex"} gap={2} sx={{ width: "100%" }}>
          <Button
            variant={
              data.confirmStatus === ConfirmStatus.NOT_READY
                ? "outlined"
                : data.confirmStatus === ConfirmStatus.READY
                  ? "contained"
                  : "blur"
            }
            color={
              data.confirmStatus === ConfirmStatus.READY
                ? "primary"
                : data.confirmStatus === ConfirmStatus.NOT_READY
                  ? "info"
                  : "success"
            }
            fullWidth
            disabled={data.confirmStatus === ConfirmStatus.NOT_READY}
            onClick={handleSubmit}
            sx={{
              ":disabled": {
                border: "none",
              },
            }}
          >
            <IconButton sx={{ paddingY: 0 }}>
              {getConfirmButton("icon")}
            </IconButton>
            {getConfirmButton("label")}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            sx={{ width: pxToRem(162) }}
            onClick={exportExcel}
          >
            {" "}
            Xuất Excel
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MonthlyTimeSheet;
